import { IsNotEmpty, IsNumber } from 'class-validator';

export class PoliticaPermissaoCriarDto {
  @IsNumber()
  @IsNotEmpty()
  permissaoId: number;
}
